(() => {
  const SELECTOR_DRAWER = '[data-wp-drawer]';

  function getFocusable(container) {
    return [...container.querySelectorAll(
      'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )];
  }

  function openDrawer(drawer, trigger) {
    if (!drawer) return;

    /*
     * Algunos contenedores del tema Kushi usan sticky, transform u overflow.
     * Eso puede encerrar un position: fixed dentro de la columna de producto.
     * Mover el drawer al body garantiza que ocupe la ventana completa.
     */
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    drawer.hidden = false;
    drawer._wpTrigger = trigger || document.activeElement;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.classList.add('wp-drawer-open');

    const focusables = getFocusable(drawer);
    if (focusables.length) focusables[0].focus();
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('wp-drawer-open');

    window.setTimeout(() => {
      drawer.hidden = true;
      if (drawer._wpTrigger) {
        drawer._wpTrigger.setAttribute('aria-expanded', 'false');
        drawer._wpTrigger.focus();
      }
    }, 280);
  }

  function bindDrawers(root = document) {
    root.querySelectorAll('[data-wp-drawer-open]').forEach((button) => {
      if (button.dataset.wpBound) return;
      button.dataset.wpBound = 'true';
      button.addEventListener('click', () => {
        const drawer = document.getElementById(button.dataset.wpDrawerOpen);
        button.setAttribute('aria-expanded', 'true');
        openDrawer(drawer, button);
      });
    });

    root.querySelectorAll(SELECTOR_DRAWER).forEach((drawer) => {
      if (drawer.dataset.wpBound) return;
      drawer.dataset.wpBound = 'true';

      drawer.querySelectorAll('[data-wp-drawer-close]').forEach((button) => {
        button.addEventListener('click', () => closeDrawer(drawer));
      });

      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeDrawer(drawer);
        if (event.key !== 'Tab') return;

        const focusables = getFocusable(drawer);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    });
  }

  async function addLookProduct(form) {
    const button = form.querySelector('.wp-look-product__add');
    const normal = button.querySelector('span:first-child');
    const loading = button.querySelector('.wp-look-product__loading');
    const formData = new FormData(form);

    button.disabled = true;
    if (normal) normal.hidden = true;
    if (loading) loading.hidden = false;

    try {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });

      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'No se pudo agregar el producto.');

      if (cart && typeof cart.renderContents === 'function' && result.sections) {
        cart.renderContents(result);
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      if (normal) normal.textContent = 'Agregado';
      window.setTimeout(() => {
        if (normal) normal.textContent = 'Agregar al carrito';
      }, 1600);
    } catch (error) {
      console.error(error);
      if (normal) normal.textContent = 'Intenta nuevamente';
    } finally {
      button.disabled = false;
      if (normal) normal.hidden = false;
      if (loading) loading.hidden = true;
    }
  }

  function bindLookForms(root = document) {
    root.querySelectorAll('[data-wp-look-form]').forEach((form) => {
      if (form.dataset.wpBound) return;
      form.dataset.wpBound = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        addLookProduct(form);
      });
    });
  }

  const wpReviewsState = {
    observer: null,
    poller: null,
    timeout: null,
    initialized: false
  };

  function extractReviewScore(source, ratingEl) {
    const candidates = [
      ratingEl?.dataset?.score,
      ratingEl?.dataset?.rating,
      ratingEl?.getAttribute?.('data-score'),
      ratingEl?.getAttribute?.('data-rating'),
      ratingEl?.getAttribute?.('aria-label'),
      ratingEl?.getAttribute?.('title')
    ];

    for (const candidate of candidates) {
      if (candidate === null || candidate === undefined || candidate === '') continue;
      const match = String(candidate).replace(',', '.').match(/([0-5](?:\.\d+)?)/);
      if (match) {
        const score = Number(match[1]);
        if (Number.isFinite(score)) return Math.max(0, Math.min(5, score));
      }
    }

    if (ratingEl) {
      const activeStars = ratingEl.querySelectorAll(
        '.jdgm-star.jdgm--on, .jdgm-star[data-score]:not(.jdgm--off), [class*="star"][class*="active"], [class*="star"][class*="filled"]'
      ).length;
      if (activeStars > 0) return Math.min(5, activeStars);
    }

    const sourceActiveStars = source.querySelectorAll(
      '.jdgm-star.jdgm--on, [class*="star"][class*="active"], [class*="star"][class*="filled"]'
    ).length;
    if (sourceActiveStars > 0) return Math.min(5, sourceActiveStars);

    return 5;
  }

  function createReviewStars(score) {
    const rating = document.createElement('div');
    rating.className = 'wp-featured-review-card__stars';
    rating.setAttribute('aria-label', `${score} de 5 estrellas`);

    const roundedScore = Math.round(score);
    for (let index = 1; index <= 5; index += 1) {
      const star = document.createElement('span');
      star.className = index <= roundedScore
        ? 'wp-featured-review-card__star is-active'
        : 'wp-featured-review-card__star is-inactive';
      star.textContent = '★';
      star.setAttribute('aria-hidden', 'true');
      rating.appendChild(star);
    }

    return rating;
  }

  function normalizeReview(source, showVerified) {
    const card = document.createElement('article');
    card.className = 'wp-featured-review-card';

    const ratingEl =
      source.querySelector('.jdgm-rev__rating') ||
      source.querySelector('[data-score]') ||
      source.querySelector('[data-rating]') ||
      source.querySelector('[aria-label*="star" i]');

    const titleEl =
      source.querySelector('.jdgm-rev__title') ||
      source.querySelector('[class*="review-title"]');

    const bodyEl =
      source.querySelector('.jdgm-rev__body') ||
      source.querySelector('.jdgm-rev__content') ||
      source.querySelector('[class*="review-body"]') ||
      source.querySelector('[class*="review-content"]');

    const authorEl =
      source.querySelector('.jdgm-rev__author') ||
      source.querySelector('[class*="reviewer-name"]') ||
      source.querySelector('[class*="review-author"]');

    const verifiedEl =
      source.querySelector('.jdgm-rev__buyer-badge') ||
      source.querySelector('[class*="verified"]');

    card.appendChild(createReviewStars(extractReviewScore(source, ratingEl)));

    if (titleEl && titleEl.textContent.trim()) {
      const title = document.createElement('h4');
      title.className = 'wp-featured-review-card__title';
      title.textContent = titleEl.textContent.trim();
      card.appendChild(title);
    }

    if (bodyEl && bodyEl.textContent.trim()) {
      const body = document.createElement('div');
      body.className = 'wp-featured-review-card__body';
      body.textContent = bodyEl.textContent.trim();
      card.appendChild(body);
    }

    if (authorEl && authorEl.textContent.trim()) {
      const meta = document.createElement('div');
      meta.className = 'wp-featured-review-card__meta';

      const author = document.createElement('span');
      author.className = 'wp-featured-review-card__author';
      author.textContent = authorEl.textContent.trim();
      meta.appendChild(author);

      if (showVerified && verifiedEl) {
        const verified = document.createElement('span');
        verified.className = 'wp-featured-review-card__verified';
        verified.textContent = '✓';
        verified.setAttribute('aria-label', 'Compra verificada');
        meta.appendChild(verified);
      }

      card.appendChild(meta);
    }

    return card;
  }

  function getStableReviewSource() {
    const template = document.querySelector(
      '[data-wp-featured-reviews] template[data-wp-review-source]'
    );

    if (template && template.content) {
      const wrapper = document.createElement('div');
      wrapper.appendChild(template.content.cloneNode(true));

      /*
       * En algunas instalaciones Judge.me guarda en el metafield únicamente
       * la carcasa del widget y añade las reseñas reales después mediante JS.
       * Solo usamos la plantilla si ya contiene reseñas completas.
       */
      if (getJudgeMeReviewNodes(wrapper).length) {
        return wrapper;
      }
    }

    /*
     * Fuente principal de respaldo: widget vivo de Judge.me. Esta fuente se
     * completa de forma asíncrona y el coordinador seguirá intentando leerla.
     */
    return document.querySelector(
      '#webprime-full-reviews #judgeme_product_reviews, #judgeme_product_reviews'
    );
  }

  function getJudgeMeReviewNodes(widget) {
    if (!widget) return [];

    const selectors = [
      '.jdgm-rev',
      '[data-review-id]',
      '.jdgm-review-card',
      '[class*="review-card"]'
    ];

    for (const selector of selectors) {
      const nodes = [...widget.querySelectorAll(selector)].filter((node) => {
        return node.querySelector(
          '.jdgm-rev__body, .jdgm-rev__content, [class*="review-body"], [class*="review-content"]'
        );
      });
      if (nodes.length) return nodes;
    }

    return [];
  }

  function renderFeaturedReviews() {
    const blocks = [...document.querySelectorAll('[data-wp-featured-reviews]')];
    if (!blocks.length) return false;

    const widget = getStableReviewSource();
    const reviewNodes = getJudgeMeReviewNodes(widget);
    if (!reviewNodes.length) return false;

    blocks.forEach((block) => {
      const list = block.querySelector('[data-wp-featured-reviews-list]');
      if (!list) return;

      const count = Math.max(1, Number(block.dataset.reviewCount || 3));
      const showVerified = block.dataset.showVerified === 'true';
      const selectedReviews = reviewNodes.slice(0, count);
      const signature = selectedReviews
        .map((review) => review.textContent.trim().replace(/\s+/g, ' ').slice(0, 180))
        .join('|');

      if (block.dataset.wpReviewSignature === signature && list.children.length) {
        block.hidden = false;
        return;
      }

      const fragment = document.createDocumentFragment();
      selectedReviews.forEach((review) => {
        fragment.appendChild(normalizeReview(review, showVerified));
      });

      list.replaceChildren(fragment);
      block.dataset.wpReviewSignature = signature;
      block.dataset.wpReviewsRendered = 'true';
      block.hidden = false;
    });

    return true;
  }

  function finalizeEmptyFeaturedReviews() {
    document.querySelectorAll('[data-wp-featured-reviews]').forEach((block) => {
      if (block.dataset.wpReviewsRendered === 'true') {
        block.hidden = false;
        return;
      }

      if (block.dataset.hideIfEmpty === 'true') {
        block.hidden = true;
      } else {
        block.hidden = false;
        const loading = block.querySelector('.wp-featured-reviews__loading');
        if (loading) loading.textContent = 'Todavía no hay reseñas para este producto.';
      }
    });
  }

  function scheduleFeaturedReviewRender() {
    window.clearTimeout(wpReviewsState.timeout);
    wpReviewsState.timeout = window.setTimeout(() => {
      renderFeaturedReviews();
    }, 80);
  }

  function startFeaturedReviewsCoordinator() {
    if (wpReviewsState.poller) {
      window.clearInterval(wpReviewsState.poller);
      wpReviewsState.poller = null;
    }

    wpReviewsState.initialized = true;

    /*
     * Judge.me puede sustituir completamente su widget durante la carga.
     * Por eso observamos el documento, no un nodo temporal del widget.
     */
    if (!wpReviewsState.observer) {
      wpReviewsState.observer = new MutationObserver(scheduleFeaturedReviewRender);
      wpReviewsState.observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    let attempts = 0;
    wpReviewsState.poller = window.setInterval(() => {
      attempts += 1;
      const rendered = renderFeaturedReviews();

      if (rendered || attempts >= 80) {
        window.clearInterval(wpReviewsState.poller);
        wpReviewsState.poller = null;

        if (!rendered) finalizeEmptyFeaturedReviews();
      }
    }, 250);

    window.setTimeout(() => {
      if (!renderFeaturedReviews()) finalizeEmptyFeaturedReviews();
    }, 20000);
  }

  function bindReviewScroll(root = document) {
    root.querySelectorAll('[data-wp-reviews-scroll]').forEach((button) => {
      if (button.dataset.wpBound) return;
      button.dataset.wpBound = 'true';

      button.addEventListener('click', () => {
        const target = document.getElementById('webprime-full-reviews');
        if (!target) return;

        target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        window.setTimeout(() => {
          const focusTarget =
            target.querySelector('button, a, input, [tabindex]:not([tabindex="-1"])') ||
            target;
          if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
          focusTarget.focus({ preventScroll: true });
        }, 550);
      });
    });
  }

  function init(root = document) {
    bindDrawers(root);
    bindLookForms(root);
    bindReviewScroll(root);
    startFeaturedReviewsCoordinator();
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', () => init());
  document.addEventListener('shopify:block:deselect', () => init());
  document.addEventListener('shopify:section:select', () => init());
})();
